// Compose
import { compose } from 'recompose'
import { connect } from 'react-redux'
// Component pieces
import renderer from './renderer'
import { isAppLoading } from '../../../app/selectors'

const mapStateToProps = (state) => ({ isLoading: isAppLoading(state) })

const MinimumWageHelpComponent = compose(connect(mapStateToProps))(renderer)

export default MinimumWageHelpComponent
